import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { HttpClient } from '@angular/common/http';
import { bmxurl, getAccess } from 'src/globals';
import { Router } from '@angular/router';
import {MessageService} from 'primeng/api';

import { cTillproduct } from 'src/types/tillproduct';
import { departments_returndata } from 'src/types/departments_returndata';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';


@Component({
  selector: 'app-tillproductsedit',
  templateUrl: './tillproductsedit.component.html',
  styleUrls: ['./tillproductsedit.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TillproductseditComponent implements OnInit {
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  Product: cTillproduct;
  httpResponse: any;
  id: string;
  pageReady: boolean = true;
  ListDepartments: any;

  productNameValid: boolean = true;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;

  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

  kitchenItemOptions: any[] = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ];
  
  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private messageService: MessageService, private globalService: GlobalService) { 
    this.Product = {
      id: null,
      tillproductid: null,
      name: "",
      venueid: this.VenueID,
      disabled: false,
      departmentId: "",
      tilldepartment: null,
      colour: "",
      price: 0,
      options: [],
      kitchenitem: false
    }


  }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        this.AccessAllowed = true;
        //if(getAccess("TILLDEPARTMENTS", user)){
          this.AccessAllowed = true;
          this.id = this.route.snapshot.paramMap.get('id');
    
    
          this.http.get(bmxurl + "TillDepartmentsList/" + this.VenueID + "/false").subscribe(response => {
            this.httpResponse = response
            if(this.httpResponse.succeeded)
            {
              this.ListDepartments = (response as departments_returndata).data;

              if (this.id === "0") {
                this.Product = {
                  id: null,
                  tillproductid: null,
                  name: "",
                  venueid: this.VenueID,
                  disabled: false,
                  departmentId: "",
                  tilldepartment: null,
                  colour: "",
                  price: 0,
                  options: [],
                  kitchenitem: false
                };
                const deptId = this.route.snapshot.queryParamMap.get('deptId');
                if (deptId) {
                  const dept = this.ListDepartments.find((d: any) => d.id === deptId);
                  if (dept) {
                    this.Product.tilldepartment = dept;
                    this.Product.departmentId = dept.id;
                  }
                }
              }

              if(this.id != "0")
              {
                this.pageReady = false;
                this.http.get(bmxurl + "TillProduct/" + this.VenueID + "/" + this.id).subscribe(response => {
                  this.httpResponse = response
                  if (this.httpResponse.succeeded)
                  {
                    const rawData = this.httpResponse.data;
                    const data: cTillproduct = Array.isArray(rawData) ? rawData[0] : rawData as cTillproduct;
                    if (data)
                    {
                      this.Product = {
                        id: data.id,
                        tillproductid: data.tillproductid,
                        name: data.name,
                        venueid: data.venueid,
                        disabled: data.disabled,
                        departmentId: data.departmentId,
                        tilldepartment: data.tilldepartment,
                        colour: data.colour,
                        price: data.price,
                        options: data.options ?? [],
                        kitchenitem: data.kitchenitem ?? false
                      };
                      this.pageReady = true;
                    }
                    else
                    {
                      this.messageService.add({severity:'warn', summary:'Not Found', detail:'Product could not be loaded'});
                      this.pageReady = true;
                    }
                  }
                  else
                  {
                    this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting product: ' + (this.httpResponse.messages?.[0] ?? 'Unknown error')});
                    this.pageReady = false;
                  }
                }, error => {
                  this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting classes, error:' + error.messages[0]});
                  this.pageReady = false;
                });
              }
      
            }
            else
            {
              this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error getting Departments, error: ' + this.httpResponse.messages[0]});
            }
          }, error => {
            this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Departments, error: ' + error.messages});
          });
        //}

        this.CompletedLoading = true;
    
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });


    

  }

  updateData()
  {
    if (this.DoValidCheck())
    {
       this.Product.departmentId = this.Product.tilldepartment.id;
      if(this.id == "0")
      {
        this.http.post<cTillproduct>(bmxurl + "/TillProduct", this.Product).subscribe(response => {
          this.httpResponse = response
            if(this.httpResponse.succeeded)
            {
              this.messageService.add({severity:'success', summary:'Saved', detail:'Class successfully updated'});
              this.router.navigateByUrl("/tillproducts/" + this.Product.departmentId);

              
            }
            }, error => {
              this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages});
          })
      }
      else
      {
        this.Product.disabled = false;
        
        this.http.put<cTillproduct>(bmxurl + "/TillProduct", this.Product).subscribe(response => {
        this.httpResponse = response
          if(this.httpResponse.succeeded)
          {
            this.messageService.add({severity:'success', summary:'Saved', detail:'Class successfully updated'});
            this.router.navigateByUrl("/tillproducts/" + this.Product.departmentId);
          }
          }, error => {
            this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages});
        })
      }
    }
  }

  DoValidCheck()
  {
    let AllValid = true;

    if(this.Product.name == null || this.Product.name == "")
    {
      AllValid = false;
      this.productNameValid = false;
    }
    else
    {
      this.productNameValid = true;
    }

    return AllValid;
  }

  returnToList()
  {
    const deptId = this.Product.tilldepartment?.id || this.Product.departmentId;
    this.router.navigateByUrl("/tillproducts/" + deptId);
  }
}
